;(function () {
  angular.module('contrast.validation').directive('validUsername', function () {
    const INVALID_USERNAME = /[!@#$%^&*()+_={}[\]\\|:";<>,?/~`]/
    const VALID_EMAIL =
      /^[_A-Za-z0-9'\-+]+(\.[+_A-Za-z0-9'-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/
    return {
      require: 'ngModel',
      link: function (_scope, _elm, _attrs, ctrl) {
        ctrl.$validators.username = function (_modelValue, viewValue) {
          return (
            angular.isUndefined(viewValue) ||
            viewValue === '' ||
            viewValue === null ||
            VALID_EMAIL.test(viewValue) ||
            !INVALID_USERNAME.test(viewValue)
          )
        }
      }
    }
  })
})()
